/**
 * Authentication utilities for admin pages
 */

import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import { signOutCompletely } from '../../firebase/config';

/**
 * Custom hook for handling logout functionality
 * Can be used across all admin pages
 */
export const useLogout = () => {
  const navigate = useNavigate();
  const toast = useToast();
  
  const handleLogout = async () => {
    try {
      console.log('[ADMIN AUTH] Logging out user');
      
      // Use the enhanced signOutCompletely function
      const success = await signOutCompletely();
      
      if (success) {
        // Show success toast
        toast({
          title: 'Logged out successfully',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        
        // Redirect to login page
        navigate('/admin/login');
      } else {
        throw new Error('Logout failed');
      }
    } catch (error) {
      console.error('[ADMIN AUTH] Error during logout:', error);
      
      toast({
        title: 'Logout error',
        description: 'There was an error logging out. Please try again.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };
  
  return { handleLogout };
};
